import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Autoatendimento from './pages/Autoatendimento';
import ProtectedRoute from './components/ProtectedRoute';
import LoginPage from './pages/Login'
import PrintEtiqueta from './pages/PrintEtiqueta'

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/autoatendimento"
          element={
            <ProtectedRoute>
              <Autoatendimento />
            </ProtectedRoute>
          }
        />
        <Route
          path="/impressao"
          element={
            <ProtectedRoute>
              <PrintEtiqueta />
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
};

export default App;
